import { Col, Typography } from "antd";
import "./newmain.css";

interface category {
  id: number;
  guid: string;
  parent: null | category;
  price: {
    id: number;
    name: string;
    description: string;
    validFrom: string;
    validTo: string;
    isActive: boolean;
  };
  listOrder: number;
  name: string;
  description: string;
  color: string;
  image: null | string;
  isActive: boolean;
}

type PropsType = {
  categories: category[];
  setSelectedCategory: React.Dispatch<React.SetStateAction<number>>;
  selectedCategory: number;
};
const CategoriesList = ({
  categories,
  setSelectedCategory,
  selectedCategory,
}: PropsType) => {
  return (
    <>
      {categories &&
        categories.map((category: category, index: number) => {
          return (
            <Col
              span={4}
              style={
                selectedCategory === category.id
                  ? { backgroundColor: "#1677FF", color: "#fff" }
                  : {}
              }
              className="category-item"
              key={index}
              onClick={() => setSelectedCategory(category.id)}
            >
              <img
                src={require("./Images/default-cat-icon.png")}
                alt=""
                style={{ marginTop: "10px" }}
              />
              <Typography
                style={
                  selectedCategory === category.id
                    ? {
                        color: "#fff",
                        textAlign: "center",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        lineHeight: "1.2",
                      }
                    : {
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        lineHeight: "1.2",
                      }
                }
              >
                {category.name}
              </Typography>
            </Col>
          );
        })}
    </>
  );
};
export default CategoriesList;
